module.exports = __webpack_public_path__ + "static/media/paperclip.91ec399a.svg";